import { Minus, TrendingDown, TrendingUp } from "lucide-react";

const ZERO = "non calcolabile (punteggio di partenza 0)";

export const growth = (current, reference) => {
    if (reference === 0) return { text: ZERO, dir: null };
    const pct = Math.round(((current - reference) / reference) * 1000) / 10;
    const abs = Math.abs(pct).toLocaleString("it-IT", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const dir = pct > 0 ? "up" : pct < 0 ? "down" : "flat";
    return { text: `${dir === "up" ? "+" : dir === "down" ? "−" : ""}${abs}%`, dir };
};

const WORD = { up: "in crescita", down: "in calo", flat: "invariato" };
const ICON = { up: TrendingUp, down: TrendingDown, flat: Minus };

export const Growth = ({ current, reference, suffix, testId }) => {
    const g = growth(current, reference);
    const Icon = g.dir && ICON[g.dir];
    return (
        <span className="inline-flex items-center gap-1.5" data-testid={testId}>
            {Icon && <Icon aria-hidden="true" size={18} className="shrink-0" />}
            <span>{g.dir ? `${g.text} ${suffix} · ${WORD[g.dir]}` : `${suffix}: ${g.text}`}</span>
        </span>
    );
};

// items newest first
export const GrowthSummary = ({ items }) => {
    if (!items || items.length < 2) return null;
    const [latest, prev] = items;
    const first = items[items.length - 1];
    return (
        <ul className="mt-4 space-y-1 text-sm text-left" data-testid="score-growth">
            <li><Growth current={latest.score_total} reference={prev.score_total} suffix="rispetto al precedente" testId="growth-vs-previous" /></li>
            <li><Growth current={latest.score_total} reference={first.score_total} suffix="rispetto al primo" testId="growth-vs-first" /></li>
        </ul>
    );
};
